<template>
    <div>
        <template v-if="laudo">
                                
            <az-empty-state v-if="!laudo.resps || !laudo.resps.length" 
                icon2="fa-solid fa-user-check"
                :icon="icon ? icon : 'no'"
                msg="Nenhum usuário responsável definido."
                action="Incluir"
                :method="incluir_resp" />

            <div v-else class="mb-3">
                <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                    <tr>
                        <td class="text-nowrap">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                <span class="badge mr-1" :class="classe_selecionada == classe ? 'badge-success' : 'badge-secondary'" >
                                    {{ classe }}
                                </span>
                            </a>
                        </td>
                    </tr>
                </table>

                <div class="form-row" v-for="(resp, irx) in laudo.resps" :key="irx">
                    <div class="col col-12 col-md-3">
                        <az-input 
                            sizing="sm"
                            v-if="resp.usuario"
                            :edicao="false"
                            v-model="resp.usuario.st_login">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-danger" @click="laudo.resps.splice(irx, 1)" v-if="!resp.id_laudo_usuario">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                    <span v-else class="input-group-text">
                                        <i class="fa fa-user fa-fw"></i>
                                    </span>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            v-else
                            sizing="sm"
                            type="select" 
                            optionsMode="aql"
                            optionsDisplay="search"
                            optionsName="usuarios-laudo-resp"
                            service="usuarios.index"
                            :optionsParm="{ perfil: 13, ativos: true }"
                            :optionsFilter="classe_selecionada ? { js_classes: classe_selecionada } : null"
                            placeholder="Selecionar Responsável..."
                            required
                            :validate="validate"
                            v-model="resp.usuario">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-danger" @click="laudo.resps.splice(irx, 1)" v-if="!resp.id_laudo_usuario">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                    <span v-else class="input-group-text">
                                        <i class="fa fa-user fa-fw"></i>
                                    </span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input 
                            sizing="sm"
                            :edicao="false"
                            :value="resp.created_at ? $util.getFormatDate(resp.created_at, 'DD/MM') + ' ' + resp.created_at.slice(11,16) : ''">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            sizing="sm"
                            type="select"
                            optionsMode="aql"
                            service="status_laudos.index"
                            optionsData="id_status_laudo"
                            placeholder="Status..."
                            v-model="resp.id_status_laudo" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input 
                            sizing="sm"
                            placeholder="Observação..."
                            v-model="resp.st_obs">
                            <template v-slot:button-pre v-if="false && change_status">
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-danger" @click="laudo.resps.splice(irx, 1)" v-if="!resp.id_laudo_usuario">
                                        <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                    </button>
                                    <span v-else class="input-group-text">
                                        <i class="fa fa-user fa-fw"></i>
                                    </span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-1">
                        <az-input 
                            sizing="sm"
                            type="checkbox-group"
                            label="Ativo"
                            v-model="resp.fl_ativo" />
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-outline-primary mt-1" @click="incluir_resp()">
                    <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            classe_selecionada: null,
            classes: null, 
        }
    },

    components: {
        AzEmptyState,
        AzInput,
    },

    props: ['laudo', 'validate', 'icon', 'change_status', 'status_selec'],

    computed: { 
        lista_usuarios: function () { 
            return this.$store.state.options['usuarios-laudo-resp'] || [];
        },

        lista_classes: function () { 
            if ( !this.classes ) 
                return [];

            let lista = _.cloneDeep(this.classes);
            
            return _.uniq(lista.sort()); 

                //this.lista_usuarios.filter(item => item.js_classes)
                    //.flatMap(item => item.js_classes)
                    //.sort()
            //);
        },

        resp_selected: function () { 
            if ( !this.laudo || !this.laudo.resps )
                return null;

            return _.findLastIndex(this.laudo.resps, item => { 
                return item.fl_ativo;
            });
        },
    },

    methods: { 
        filtrar (classe) { 
            if ( this.classe_selecionada === classe ) { 
                this.classe_selecionada = null;
            } else { 
                this.classe_selecionada = classe;
            }
        },

        incluir_resp () { 
            this.laudo.resps.push({ 
                id_laudo_usuario: null, 
                id_usuario: null,
                usuario: null,
                fl_ativo: 1, 
                id_laudo: this.laudo.id_laudo,
                st_obs: this.status_selec ? this.status_selec.search : '', 
                id_status_laudo: this.status_selec ? this.status_selec.id_status_laudo : "", 
            });
        },
    },

    mounted() { 
        this.$util.loadItem(this, {
            service: 'usuarios',
            func: 'tags',
        })
        .then(res => {
            this.classes = res;

            if ( this.status_selec && this.status_selec.st_resp_classe && this.classes && this.classes.includes(this.status_selec.st_resp_classe) ) { 
                this.classe_selecionada = this.status_selec.st_resp_classe;
            }
        }); 

    }
}
</script>
